import { render, staticRenderFns } from "./ItsSalesOuterAbroadFeeDetail.vue?vue&type=template&id=5337a65c&scoped=true&"
import script from "./ItsSalesOuterAbroadFeeDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesOuterAbroadFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesOuterAbroadFeeDetail.vue?vue&type=style&index=0&id=5337a65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337a65c",
  null
  
)

export default component.exports